import { MarketingHome } from '@/components/organisms';

export function HomePage() {
  return <MarketingHome />;
}
